export const localFiles = {
  images: {
    noPictureAvatar: '/images/no_picture.jpeg',
    unknownUser: '/images/user-unknown.png',
  },
};
